import { middleofficeRequest } from '../../../axios'

const login = async (email, password) => {
  const response = await middleofficeRequest.post(
    `middleoffice/auth/login`,
    JSON.stringify({ email, password }),
    {
      headers: { 'Content-Type': 'application/json' },
    }
  )
  return response.data
}

export default {
  login,
}
